<template>
  <div class="n_continer">
    <div class="n_top">
      <p class="n_phone">手机号码</p>
      <input type="number" placeholder="请输入激活手机号码" />
      <div class="n_flex n_justfiy n_backf">
        <div class="n_flex">
          <span class="iconfont icondingwei3"></span>
          <p>添加收货地址</p>
        </div>
        <span class="iconfont iconnext"></span>
      </div>
    </div>
    <p class="n_selsectcard">选择礼包</p>
    <div class="n_card">
      <p class="n_pricecard">5000元礼包</p>
      <div class="n_cardList">
        <div class="n_flex n_carweid">
          <div class="n_rigt" v-for="i in 2" :key="i">
            <img class="n_cardimg" src alt />
            <p class="n_goodsname">
              <span>茅台酱香</span>
              <span>x</span>
              <span>99</span>
            </p>
          </div>
        </div>
      </div>
      <div class="n_footer n_flex n_justfiy">
        <div class="n_price">¥5000.00</div>
        <div class="n_flex">
          <span class="iconfont iconjian2"></span>
          <input class="n_numbr" type="number" />
          <span class="iconfont iconjia3"></span>
          <span style="marginLeft: 5px">套</span>
        </div>
      </div>
    </div>
    <div class="n_btn">立即购买</div>
    <div style="height:20px"></div>
  </div>
</template>

<script>
export default {
  name: '123',
}
</script>


<style lang="scss" scoped>
.n_continer {
  height: 100%;
  background: rgba(247, 248, 250, 1);
}
.n_top {
  width: 100%;
  box-sizing: border-box;
  padding: 44px 20px 28px 20px;
  background: #d8d8d8 linear-gradient(184deg, #ff3333 0%, #ff5720 100%);
  border-radius: 0px 0px 20px 20px;
}
.n_top input {
  height: 59px;
  background: #d8d8d8 linear-gradient(184deg, #ff3333 0%, #ff5720 100%);
  color: rgba(255, 255, 255, 1);
  margin-top: 10px;
}
.n_top input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 1);
  font-size: 42px;
}
.n_flex {
  display: flex;
  align-items: center;
}
.n_justfiy {
  justify-content: space-between;
}
.icondingwei3 {
  font-size: 50px;
  color: rgba(255, 87, 32, 1);
}
.n_backf {
  margin-top: 20px;
  padding: 65px 30px;
  background: #ffffff;
  border-radius: 20px;
}
.n_phone {
  font-size: 26px;
  color: #ffd5d3;
}
.n_card {
  width: 710px;
  height: 498px;
  padding: 0 20px;
  box-sizing: border-box;
  background: #ffffff;
  margin-left: 20px;
}
.n_selsectcard {
  margin-top: 40px;
  font-size: 32px;
  color: #323233;
  margin-left: 30px;
  margin-bottom: 20px;
}
.n_cardimg {
  width: 198px;
  height: 198px;
}
.n_goodsname {
  text-align: center;
}
.n_cardList {
  padding: 35px 38px 20px;
  border-radius: 20px;
}
.n_carweid {
  overflow: hidden;
  box-sizing: border-box;
}
.n_rigt {
  margin-right: 18px;
}
.n_numbr {
  width: 64px;
  height: 64px;
  padding: 0 10px;
  box-sizing: border-box;
}
.iconjian2 {
  font-size: 56px;
}
.iconjia3 {
  font-size: 56px;
}
.n_footer {
  background: #fff2f3;
  border-radius: 20px;
  padding: 16px 20px;
}
.n_price {
  font-size: 36px;
  color: #ee0a24;
}
.n_pricecard {
  padding-top: 35px;
}
.n_btn {
  width: 686px;
  height: 96px;
  line-height: 96px;
  text-align: center;
  background: #ee0a24;
  border-radius: 48px;
  font-size: 28px;
  color: #ffffff;
  margin: 286px auto 0;
}
</style>
